import { Component, Input } from '@angular/core';

@Component({
  selector: 'feature-card',
  template: `
<!-- <div class="feature-card wow fadeInUp" data-wow-delay="0.2s">
      <img [src]="feature.icon" width="400" height="200" [alt]="feature.title"  priority/>
      <h3 class="text-color">{{title }}</h3>
      <p>{{ feature.description }}</p>
    </div> -->
        `,
  styles: [
    `
    :host {
      display: block;
      height: 100%;
    }

    .feature-card {
      text-align: center;
      padding: 2.5rem 2rem;
      background-color: var(--surface-color);
      color: var(--text-main);
      border-radius: 1rem;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      border: 1px solid var(--grey-color);
      /* Animation default hidden state controlled by wow.js */
      visibility: hidden;
    }

    .feature-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
    }

    .icon {
      margin-bottom: 1.5rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 4rem;
      height: 4rem;
      background-color: #e0f2fe; /* Light sky blue circle */
      border-radius: 50%;
      color: var(--primary-color);
    }

    .icon img {
      width: 2.5rem;
      height: 2.5rem;
      object-fit: contain;
    }

    .icon i {
      font-size: 2rem;
      color: var(--primary-color);
    }

    h3 {
      margin: 0 0 1rem 0;
      font-size: 1.25rem;
      font-weight: 600;
      color: var(--secondary-color);
    }

    p {
      font-size: 1rem;
      color: var(--text-light);
      line-height: 1.6;
      margin: 0;
    }
    `
  ],
})
export class FeatureCardComponent {
  @Input() icon!: string;
  @Input() title!: string;
  @Input() description!: string;
}
